<template>
  <img src="@/assets/img/introduce_banner.jpg" class="w-full max-h-[25rem] min-h-[11.25rem] object-cover"/>

  <main class="max-w-[1200px] mx-auto mb-20">
    <div>
      <h1 class="font-bold text-center my-10">소개</h1>
    </div>

    <div class="mb-12 px-6 pb-7 border-b flex justify-center gap-5 max-lg:grid max-lg:grid-cols-3 max-lg:gap-2">
      <router-link to="/introduce/1"  class="sec_btn w-full text-lg py-4 max-lg:text-base" active-class="!text-blue-800 !border-blue-800 !font-semibold">인사말</router-link>
      <router-link to="/introduce/2"  class="sec_btn w-full text-lg py-4 max-lg:text-base" active-class="!text-blue-800 !border-blue-800 !font-semibold">총회교육 정신</router-link>
      <router-link to="/introduce/3"  class="sec_btn w-full text-lg py-4 max-lg:text-base" active-class="!text-blue-800 !border-blue-800 !font-semibold">총회교육 사역</router-link>
      <router-link to="/introduce/4"  class="sec_btn w-full text-lg py-4 max-lg:text-base" active-class="!text-blue-800 !border-blue-800 !font-semibold">섬기는 이들</router-link>
      <router-link to="/introduce/5"  class="sec_btn w-full text-lg py-4 max-lg:text-base" active-class="!text-blue-800 !border-blue-800 !font-semibold">찾아오시는 길</router-link>
    </div>
    
    <!-- 인사말 -->
    <div class="w-fit mx-auto max-lg:px-5"  v-if="introIdx === '1'">
      <h2 class="nanum-square font-bold text-center">총회교육닷컴을 방문해주신 여러분께 감사드립니다.</h2>

      <pre class="pretendard whitespace-pre-line py-20 text-xl max-lg:text-base">총회설립 이후 지금까지 총회교육은 정확무오한 하나님의 말씀을
        변화하는 세대 속에 잘 전수하고 삶에 실천할 수 있는 역량을 키우기 위해 진력해 왔습니다.

        미래 4차 산업혁명의 급격한 변화 속에서도 주님의 지상명령을 준행하며, 
        주님의 몸된 교회를 세우고, 미래 세대가 세상에서 빛과 소금의 역할을 감당할 수 있도록 힘쓸 것입니다.

        총회교육개발원은 기독교교육 전문기관으로 교육정책을 입안하고 교육과정을 설계하고,
        전문적인 교육 컨텐츠를 주일학교 및 교회교육의 현장에 보급하는 일에 최선을 다할 것입니다.

        이를 통해 하나님이 영광받으시는 교육, 하나님이 기뻐하시는 삶, 말씀으로 세상에 도전하고 위로하는
        선한 영향을 이뤄나갈 것입니다.</pre>

        <img src="@/assets/img/introduce1_desc.svg" class="mx-auto"/>
    </div>

    <!-- 총회교육 정신 -->
    <div class="w-full mx-auto max-lg:px-5"  v-if="introIdx === '2'">
      <div class="flex gap-20 mb-10 items-center max-lg:flex-col max-lg:gap-6">
        <div class="spirit_tt">
          교육이념
        </div>
        <pre class="pretendard whitespace-pre-line text-xl max-lg:text-base max-lg:text-center">총회교육의 이념은
          “정확무오한 성경에 근거한 개혁주의 신앙고백 (웨스터민스터 표준서들 : Westminster Standards)을
          따라 삶의 모든 영역에서 하나님 나라를 확장시키는 그리스도인을 양육하는 것이다.”
        </pre>
      </div>
      <div class="flex gap-20 mb-10 items-center max-lg:flex-col max-lg:gap-6">
        <div class="spirit_tt">
          교육목적
        </div>
        <pre class="pretendard whitespace-pre-line text-xl max-lg:text-base max-lg:text-center">총회 교육의 이념에 근거한 교육목적은
          “성경교육을 통해 삼위일체 하나님을 믿고 사랑하며 섬기게 하며,
          하나님의 참된 그리스도인의 정체성을 가지고 세상을 변화시키며, 하나님께 영광을 돌리도록 하는 것이다.”
        </pre>
      </div>
      <div class="flex gap-20 mb-10 items-center max-lg:flex-col max-lg:gap-6">
        <div class="spirit_tt">
          교육목표
        </div>
        <pre class="pretendard whitespace-pre-line text-xl max-lg:text-base max-lg:text-center">총회교육이 추구하는 교육목표는
          “정확무오한 신구약 성경 66권을 체계적으로 교육하여 기독교적 세계관을 형성하고, 
          개혁주의 신학(교리)에 근거한 삶의 원리를 깨달아서, 삶의 모든 영역에서 하나님의 형상으로 지음받은 거룩한 성품을 내면화하여,
          하나님을 사랑하고 이웃을 사랑하며, 세상의 소금과 빛이 되는 참된 그리스도인을 양성해 나가는 것이다.”
        </pre>
      </div>
    </div>

    <!-- 총회교육 사역 -->
    <div class="w-fit mx-auto max-lg:px-5"  v-if="introIdx === '3'">
      <h2 class="nanum-square font-bold text-center">하나님 나라 확장</h2>
      <img src="@/assets/img/introduce3_expand.png" class="mx-auto mt-20 mb-20 max-lg:hidden"/>
      <img src="@/assets/img/introduce3_expand_m.png" class="mx-auto mt-14 mb-20 lg:hidden"/>

      <div class="flex w-fit mx-auto mb-10 lg:gap-2 text-center bg-gray-600 text-white px-4 py-2 text-xl max-lg:text-base max-lg:flex-col">
        <span>하나님 나라의 소금과 빛이 되는</span>
        <span>참된 그리스도인 양성</span>
      </div>

      <div class="max-w-5xl pt-20 mx-auto">
        <div class="grid-custom grid gap-x-9 gap-y-4 items-center mb-16 break-keep max-lg:flex max-lg:flex-col max-lg:text-center">
          <h1 class="nanum-square font-extrabold text-orange-600">01</h1>
          <h4 class="font-semibold max-w-[34.5rem] leading-7">총회교육개발원은 하나님 중심, 말씀중심의 교회교육의 허브가 되는 교육정책을 실현할 것이다.</h4>
          <p class="text-gray-600 text-lg leading-6  max-lg:text-base" style="grid-area: 2 / 2">
            전능하신 하나님은 역사를 주관하시고 인류의 흥망성쇄를 주관하신다.또한 말씀은 생명의 원천이요 교육의 영원한 교과서이다. 총회교육개발원은 성부, 성자, 성령 하나님 중심, 성경 말씀 기반의 개혁주의 신학에 입각한기독교교육철학과 교육과정을 개발하고 시행하여 종국적으로는 주일학교와 교회교육 전반의 구심점이 될 것이다.
          </p>
        </div>

        <div class="grid-custom grid gap-x-9 gap-y-4 items-center mb-16 break-keep max-lg:flex max-lg:flex-col max-lg:text-center">
          <h1 class="nanum-square font-extrabold text-amber-500">02</h1>
          <h4 class="font-semibold max-w-[34.5rem] leading-7">총회교육개발원은 교회, 가정, 학교를 연계하며 <br class="max-md:hidden">기독교교육 생태계의 선순환적 구조를 복원할 것이다.</h4>
          <p class="text-gray-600 text-lg leading-6  max-lg:text-base" style="grid-area: 2 / 2">
            그동안 교회의 교육은 교회중심에 맞춘 주일학교의 한계를 넘어서지 못하였다. 가정과 학교의 영역을 고려하지 않은 교회의 교육은 단회적이며 교육의 영향력을 극대화할 수 없는 바,교회, 가정, 학교를 포괄하는 선순환적 교회교육 생태계를 이뤄가도록 해야 한다. 미래 세대들이 숨 쉬고 활동하는 전 공간을 교육의 영역으로 여기며 그 교육환경을 하나님이 기뻐하시는 교육터전으로 만들어갈 것이다.
          </p>
        </div>

        <div class="grid-custom grid gap-x-9 gap-y-4 items-center mb-16 break-keep max-lg:flex max-lg:flex-col max-lg:text-center">
          <h1 class="nanum-square font-extrabold text-cyan-500">03</h1>
          <h4 class="font-semibold max-w-[34.5rem] leading-7">총회교육개발원은 4차 산업혁명에 맞춘 <br class="max-md:hidden">온라인과 오프라인을 융합한 스마트 러닝이 이뤄지도록 할 것이다.</h4>
          <p class="text-gray-600 text-lg leading-6  max-lg:text-base" style="grid-area: 2 / 2">
            오늘날 인공지능 기반의 온라인 교육환경은 거의 혁명과 같이 우리에게 다가오고 있다. 온라인과 오프라인을 연계한 교육은 거의 일상적인 것이 되었고, 앞으로 스마트 기기를 활용한 교육은 그 외연이 점점 확장될 것이다. 기존의 면대면 오프라인 교육이 효율적으로 잘 이뤄지도록 할 뿐아니라 온라인 기반의 스마트 러닝이 되도록 할 것이다. 미래 세대의 눈높이에 맞으며 그들과 호흡을 같이 할 온라인 교육에 중점을 두며 오프라인 교육을 극대화 할 수 있는 교육을 이루어 나갈 것이다.
          </p>
        </div>

        <div class="grid-custom grid gap-x-9 gap-y-4 items-center mb-16 break-keep max-lg:flex max-lg:flex-col max-lg:text-center">
          <h1 class="nanum-square font-extrabold text-indigo-800">04</h1>
          <h4 class="font-semibold leading-7">총회교육개발원은 말씀과 삶이 균형을 이루는 교육을 실현할 것이다.</h4>
          <p class="text-gray-600 text-lg leading-6  max-lg:text-base" style="grid-area: 2 / 2">
            하나님의 존귀한 말씀이 학습자의 삶에 그대로 나타나며 생활 속에 내면화 되도록 주일에 국한 되지 않고 전 삶의 영역에서 실천되어지도록 하는 교육을 펼쳐나갈 것이다. 온전한 기독교교육은 말씀과 삶의 일관적인 실천이 이뤄져 말씀으로 인한 삶의 변화가 표면화 되어야 한다. 지, 정, 의가 말씀의 빛 안에서 통합되어 균형있게 실천될 수 있는 진정한 교육이 되도록 할 것이다. 이로 인해 미래 사회의 주역이 될 다음세대들은 말씀을 그들의 삶의 전 포괄적인 영역에서 실천하고,사회에 빛과 소금으로 영향력을 발휘하게 될 것이다.
          </p>
        </div>

        <div class="grid-custom grid gap-x-9 gap-y-4 items-center mb-24 break-keep max-lg:flex max-lg:flex-col max-lg:text-center">
          <h1 class="nanum-square font-extrabold text-green-600">05</h1>
          <h4 class="font-semibold max-w-[34.5rem] leading-7">총회교육개발원은 부서 간 • 세대 간 소통을 원활하게 해주어
            신앙성숙과 신앙의 전수가 이뤄지는 교육이 되도록 할 것이다.</h4>
          <p class="text-gray-600 text-lg leading-6 max-lg:text-base" style="grid-area: 2 / 2">
            미래 사회는 자연적인 출산율 저하로 인해 자라나는 세대의 급격한 감소가 예견된다. 주일학교와 교회교육의 현장에서는 대다수의 많은 교회들이 학년별 및 부서별로 교육이 이뤄지기 보다는 통합하여 운영되고 있다. 총회교육개발원에서는 현장의 요구를 면밀히 파악하여 부서별, 세대별로 원활한 소통과 양육이 잘 이뤄지도록 말씀교육이 이뤄지도록 할 것이다. 동일한 말씀을 부서간 세대간 세대 간 공유하고 이에 따라 발달특성에 맞게 학습하므로, 말씀교육을 통해 하나 됨을 경험하고 기독교적 양육과 신앙의 계승이 이뤄지는 교육이 되도록 해나갈 것이다.
          </p>
        </div>
        
      </div>

      <img src="@/assets/img/introduce3_desc.svg" class="max-lg:hidden"/>
      <img src="@/assets/img/introduce3_desc_m.svg" class="mx-auto lg:hidden"/>
      
    </div>

    <!-- 총회교육개발원 조직 -->
    <div class="w-fit mx-auto max-lg:px-5"  v-if="introIdx === '4'">
      <h2 class="nanum-square font-bold text-center mb-10">총회교육개발원 조직</h2>

      <!-- 이사회 -->
      <div class="flex gap-10 items-center my-20 max-lg:flex-col max-lg:divide-y lg:divide-x">
        <div class="flex flex-col items-center">
          <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
            <path d="M36.6406 17.8721L29.5938 24.0221L31.7047 33.1783C31.8164 33.657 31.7845 34.1579 31.6131 34.6186C31.4416 35.0792 31.1381 35.4791 30.7406 35.7682C30.3431 36.0573 29.8692 36.2229 29.3782 36.2441C28.8871 36.2654 28.4007 36.1414 27.9797 35.8877L19.9938 31.0439L12.025 35.8877C11.604 36.1414 11.1176 36.2654 10.6265 36.2441C10.1355 36.2229 9.66156 36.0573 9.26406 35.7682C8.86656 35.4791 8.56311 35.0792 8.39164 34.6186C8.22017 34.1579 8.1883 33.657 8.3 33.1783L10.4078 24.0314L3.35938 17.8721C2.98658 17.5505 2.71701 17.1261 2.58447 16.652C2.45193 16.1778 2.46232 15.6751 2.61434 15.2069C2.76635 14.7387 3.05324 14.3257 3.439 14.0199C3.82477 13.714 4.29225 13.5289 4.78282 13.4877L14.0734 12.683L17.7 4.03299C17.8894 3.57911 18.2088 3.19141 18.6181 2.9187C19.0274 2.646 19.5082 2.50049 20 2.50049C20.4918 2.50049 20.9726 2.646 21.3819 2.9187C21.7912 3.19141 22.1106 3.57911 22.3 4.03299L25.9375 12.683L35.225 13.4877C35.7156 13.5289 36.1831 13.714 36.5688 14.0199C36.9546 14.3257 37.2415 14.7387 37.3935 15.2069C37.5455 15.6751 37.5559 16.1778 37.4234 16.652C37.2908 17.1261 37.0212 17.5505 36.6484 17.8721H36.6406Z" fill="#ea580c"/>
          </svg>
          <h3 class="min-w-[12.5rem] nanum-square font-bold text-white bg-orange-600 rounded-xl px-6 py-4 mt-4 text-center" style="word-spacing: 0.75rem">이 사 회</h3>
        </div>

        <div class="flex flex-col gap-4 lg:pl-10 max-lg:pt-10 max-lg:text-center">
          <div class="md:flex md:leading-none">
            <b class="md:border-r border-black md:mr-3 md:pr-3 w-14 md:w-24">이사장</b>
            <div class="text-gray-500">송태근</div>
          </div>
          <div class="md:flex md:leading-none">
            <b class="md:border-r border-black md:mr-3 md:pr-3 w-14 md:w-24">서기</b>
            <div class="text-gray-500">이양수</div>
          </div>
          <div class="md:flex md:leading-none">
            <b class="md:border-r border-black md:mr-3 md:pr-3 w-14 md:w-24">회계</b>
            <div class="text-gray-500">홍승영</div>
          </div>
          <div class="md:flex items-center md:leading-none">
            <b class="md:border-r border-black md:mr-3 md:pr-3 w-14 md:w-24">이사</b>
            <div class="grid grid-cols-5 gap-x-3 gap-y-1 text-gray-500">
              <span>깅종준</span><span>강진상</span><span>고동훈</span><span>고문산</span><span>권순웅</span>
              <span>김재철</span><span>김창현</span><span>배만석</span><span>오원석</span><span>옥성석</span>
              <span>우상현</span><span>이정현</span><span>장봉생</span><span>깅종준</span><span>홍문수</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 자문위원 -->
      <div class="flex gap-10 items-center my-20 max-lg:flex-col max-lg:divide-y lg:divide-x">
        <div class="flex flex-col items-center">
          <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
            <g clip-path="url(#clip0_136_707)">
              <path d="M6.66666 18.3335C7.09146 18.334 7.50005 18.4966 7.80894 18.7882C8.11784 19.0799 8.30372 19.4784 8.32861 19.9025C8.35351 20.3266 8.21554 20.7441 7.94289 21.0699C7.67024 21.3956 7.28349 21.605 6.86166 21.6552L6.66666 21.6668H4.99999C4.5752 21.6664 4.16661 21.5037 3.85771 21.2121C3.54882 20.9205 3.36294 20.5219 3.33804 20.0978C3.31315 19.6738 3.45112 19.2562 3.72377 18.9304C3.99642 18.6047 4.38317 18.3953 4.80499 18.3452L4.99999 18.3335H6.66666ZM20 3.3335C20.4082 3.33355 20.8022 3.48342 21.1073 3.75469C21.4123 4.02595 21.6072 4.39974 21.655 4.80516L21.6667 5.00016V6.66683C21.6662 7.09163 21.5035 7.50022 21.2119 7.80911C20.9203 8.118 20.5217 8.30389 20.0977 8.32878C19.6736 8.35368 19.256 8.2157 18.9303 7.94305C18.6045 7.6704 18.3952 7.28366 18.345 6.86183L18.3333 6.66683V5.00016C18.3333 4.55814 18.5089 4.13421 18.8215 3.82165C19.134 3.50909 19.558 3.3335 20 3.3335ZM35 18.3335C35.4248 18.334 35.8334 18.4966 36.1423 18.7882C36.4512 19.0799 36.6371 19.4784 36.6619 19.9025C36.6868 20.3266 36.5489 20.7441 36.2762 21.0699C36.0036 21.3956 35.6168 21.605 35.195 21.6552L35 21.6668H33.3333C32.9085 21.6664 32.4999 21.5037 32.191 21.2121C31.8822 20.9205 31.6963 20.5219 31.6714 20.0978C31.6465 19.6738 31.7845 19.2562 32.0571 18.9304C32.3298 18.6047 32.7165 18.3953 33.1383 18.3452L33.3333 18.3335H35ZM8.15499 8.15516C8.44198 7.8682 8.82382 7.69582 9.22886 7.67035C9.6339 7.64488 10.0343 7.76808 10.355 8.01683L10.5117 8.15516L11.6783 9.32183C11.9772 9.62176 12.1508 10.0242 12.1637 10.4475C12.1766 10.8707 12.028 11.283 11.7479 11.6006C11.4679 11.9182 11.0774 12.1173 10.6559 12.1575C10.2343 12.1976 9.81331 12.0758 9.47833 11.8168L9.32166 11.6785L8.15499 10.5118C7.84254 10.1993 7.66702 9.77544 7.66702 9.3335C7.66702 8.89156 7.84254 8.46771 8.15499 8.15516ZM29.4883 8.15516C29.7883 7.85625 30.1907 7.68271 30.614 7.66978C31.0372 7.65686 31.4495 7.80552 31.7671 8.08558C32.0847 8.36563 32.2838 8.75608 32.324 9.17762C32.3641 9.59916 32.2423 10.0202 31.9833 10.3552L31.845 10.5118L30.6783 11.6785C30.3784 11.9774 29.9759 12.151 29.5527 12.1639C29.1294 12.1768 28.7171 12.0281 28.3995 11.7481C28.0819 11.468 27.8828 11.0776 27.8427 10.656C27.8025 10.2345 27.9243 9.81348 28.1833 9.4785L28.3217 9.32183L29.4883 8.15516ZM23.3333 30.0002C23.7754 30.0002 24.1993 30.1758 24.5118 30.4883C24.8244 30.8009 25 31.2248 25 31.6668C25 32.9929 24.4732 34.2647 23.5355 35.2024C22.5978 36.14 21.3261 36.6668 20 36.6668C18.6739 36.6668 17.4021 36.14 16.4645 35.2024C15.5268 34.2647 15 32.9929 15 31.6668C15 31.2586 15.1499 30.8646 15.4212 30.5595C15.6925 30.2545 16.0662 30.0596 16.4717 30.0118L16.6667 30.0002H23.3333ZM20 10.0002C22.0988 10.0002 24.1444 10.6605 25.8471 11.8877C27.5498 13.1149 28.8231 14.8468 29.4868 16.8379C30.1505 18.829 30.1709 20.9785 29.5451 22.9818C28.9193 24.9852 27.6791 26.7409 26 28.0002C25.7703 28.1727 25.4999 28.2829 25.215 28.3202L25 28.3335H15C14.6394 28.3335 14.2885 28.2165 14 28.0002C12.3209 26.7409 11.0807 24.9852 10.4549 22.9818C9.82906 20.9785 9.84946 18.829 10.5132 16.8379C11.1769 14.8468 12.4502 13.1149 14.1529 11.8877C15.8555 10.6605 17.9012 10.0002 20 10.0002Z" fill="#f59e0b"/>
            </g>
            <defs>
              <clipPath id="clip0_136_707">
                <rect width="40" height="40" fill="white"/>
              </clipPath>
            </defs>
          </svg>
          <h3 class="min-w-[12.5rem] nanum-square font-bold text-white bg-amber-500 rounded-xl px-6 py-4 mt-4 text-center" style="word-spacing: 0.75rem">자 문 위 원</h3>
        </div>

        <div class="lg:min-h-[15rem] flex items-center lg:pl-10 max-lg:pt-10">
          <div>
            <div class="grid grid-cols-5 gap-x-3 gap-y-1 text-gray-500">
              <span>김대훈</span><span>김서택</span><span>김한성</span><span>김희수</span><span>박재신</span><span>심욱섭</span>
              <span>윤영민</span><span>이관형</span><span>이인호</span><span>정명호</span><span>정창수</span><span>조상용</span>
              <span>홍석기</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 전문위원 -->
      <div class="flex gap-10 items-center my-20 max-lg:flex-col max-lg:divide-y lg:divide-x">
        <div class="flex flex-col items-center">
          <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
            <g clip-path="url(#clip0_136_713)">
              <path d="M4.68887 25.7777L2.57776 34.8888C2.50494 35.2219 2.50743 35.567 2.58507 35.899C2.66271 36.231 2.81352 36.5414 3.0265 36.8076C3.23948 37.0738 3.50924 37.2891 3.81607 37.4377C4.1229 37.5864 4.45906 37.6646 4.79999 37.6666C4.95884 37.6827 5.11891 37.6827 5.27776 37.6666L14.4444 35.5555L32.0444 18.0222L22.2222 8.22217L4.68887 25.7777Z" fill="#06b6d4"/>
              <path d="M37.5778 9.24463L31.0222 2.68907C30.5912 2.26026 30.008 2.01953 29.4 2.01953C28.792 2.01953 28.2088 2.26026 27.7778 2.68907L24.1333 6.33352L33.9444 16.1446L37.5889 12.5002C37.8022 12.2858 37.9711 12.0315 38.086 11.7518C38.2009 11.4721 38.2595 11.1725 38.2584 10.8701C38.2574 10.5677 38.1967 10.2685 38.08 9.98959C37.9632 9.71067 37.7925 9.45752 37.5778 9.24463Z" fill="#06b6d4"/>
            </g>
            <defs>
              <clipPath id="clip0_136_713">
                <rect width="40" height="40" fill="white"/>
              </clipPath>
            </defs>
          </svg>
          <h3 class="min-w-[12.5rem] nanum-square font-bold text-white bg-cyan-500 rounded-xl px-6 py-4 mt-4 text-center" style="word-spacing: 0.75rem">전 문 위 원</h3>
        </div>

        <div class="lg:min-h-[15rem] flex items-center lg:pl-10 max-lg:pt-10">
          <div>
            <div class="grid grid-cols-5 gap-x-3 gap-y-1 text-gray-500">
              <span>김광렬</span><span>김대혁</span><span>김수환</span><span>김요섭</span><span>김희자</span><span>신국원</span>
              <span>양신혜</span><span>유은희</span><span>이상원</span><span>이종민</span><span>정승원</span><span>조호형</span>
              <span>하재송</span><span>함영주</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 실무연구원 -->
      <div class="flex gap-10 items-center my-20 max-lg:flex-col max-lg:divide-y lg:divide-x">
        <div class="flex flex-col items-center">
          <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
            <path d="M32 0H8C5.8 0 4 1.8 4 4V36C4 38.2 5.8 40 8 40H32C34.2 40 36 38.2 36 36V4C36 1.8 34.2 0 32 0ZM8 4H18V20L13 17L8 20V4Z" fill="rgb(55 48 163)"/>
          </svg>
          <h3 class="min-w-[12.5rem] nanum-square font-bold text-white bg-indigo-800 rounded-xl px-6 py-4 mt-4 text-center" style="word-spacing: 0.75rem">실 무<br/>연 구 원</h3>
        </div>

        <div class="flex flex-col gap-4 lg:pl-10 max-lg:pt-10 max-lg:text-center">
          <div class="md:flex md:leading-none">
            <b class="md:border-r border-black md:mr-3 md:pr-3 w-14 md:w-24">원장</b>
            <div class="text-gray-500">노영주</div>
          </div>
          <div class="md:flex md:leading-none">
            <b class="md:border-r border-black md:mr-3 md:pr-3 w-14 md:w-24">선임연구원</b>
            <div class="text-gray-500">한유완</div>
          </div>
          <div class="md:flex md:leading-none">
            <b class="md:border-r border-black md:mr-3 md:pr-3 w-14 md:w-24">연구원</b>
            <div class="grid grid-cols-5 gap-x-3 gap-y-1 text-gray-500">
              <span>성초희</span><span>문성광</span><span>황성국</span><span>남기숙</span><span>배승리</span>
            </div>
            <span class="text-gray-500">서무행정 : 김희영</span>
          </div>
        </div>
      </div>

    </div>

    <!-- 찾아오시는 길 -->
    <div class="w-fit mx-auto max-lg:px-5"  v-if="introIdx === '5'">
      <h2 class="nanum-square font-bold text-center mb-10">찾아오시는 길</h2>

      <img src="@/assets/img/introduce5_temp.jpg" class="rounded-xl"/>
      <div class="flex items-center gap-2 mt-4 justify-center p-4 bg-gray-200 rounded-xl">
        <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M7.156 13.544C8.899 12.01 12 8.876 12 6C12 4.4087 11.3679 2.88258 10.2426 1.75736C9.11742 0.632141 7.5913 0 6 0C4.4087 0 2.88258 0.632141 1.75736 1.75736C0.632141 2.88258 2.37122e-08 4.4087 0 6C0 8.876 3.1 12.01 4.844 13.544C5.16211 13.8279 5.5736 13.9849 6 13.9849C6.4264 13.9849 6.83789 13.8279 7.156 13.544ZM4 6C4 5.46957 4.21071 4.96086 4.58579 4.58579C4.96086 4.21071 5.46957 4 6 4C6.53043 4 7.03914 4.21071 7.41421 4.58579C7.78929 4.96086 8 5.46957 8 6C8 6.53043 7.78929 7.03914 7.41421 7.41421C7.03914 7.78929 6.53043 8 6 8C5.46957 8 4.96086 7.78929 4.58579 7.41421C4.21071 7.03914 4 6.53043 4 6Z" fill="black"/>
        </svg>
        <p class="text-lg">(06177) 서울특별시 강남구 영동대로 330(대치동) 총회회관 6층 총회교육개발원</p>
      </div>
    </div>


    <img src="@/assets/img/logo_origin.png" class="mx-auto my-20"/>
  </main>
</template>

<script>
export default {
  data() {
    return {
      introIdx: this.$route.params.category,
    };
  },
  watch: {
    '$route.params.category'(newCategory) {
      this.introIdx = newCategory;
    },
  },
};
</script>

<style>
  .grid-custom {
    grid-template-columns: 3rem 1fr;
    grid-template-rows: auto;
  }
</style>